/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsDesignDownloadDailySummary,
    MelcoModelsDesignDownloadDailySummaryFromJSON,
    MelcoModelsDesignDownloadDailySummaryFromJSONTyped,
    MelcoModelsDesignDownloadDailySummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary
 */
export interface MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary {
    /**
     * 
     * @type {Array<MelcoModelsDesignDownloadDailySummary>}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary
     */
    list: Array<MelcoModelsDesignDownloadDailySummary>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummaryFromJSON(json: any): MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary {
    return MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummaryFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsDesignDownloadDailySummaryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummaryToJSON(value?: MelcoModelsGenericList1MelcoModelsDesignDownloadDailySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsDesignDownloadDailySummaryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


